module.exports = __webpack_public_path__ + "media/images/iconLockClosed__inactive-0f15a1c758238d7e4c9984c5cca3a733.png";